import React, { useEffect, useMemo, useState } from "react";
import TableContainer from "../../components/Common/TableContainer";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { Card, CardBody, Button, Container } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { formatDate, getRecords } from "../../services/api.service";
import { imageURL } from "./../../services/api.service";
import { exportPageData } from "./InwardFile";
import moment from "moment";

const breadcrumbItems = [];

const InwardList = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [exportData, setExportData] = useState([]);

  useEffect(() => {
    const projectId = JSON.parse(localStorage.getItem("projectID"));
    getData(projectId);
  }, [searchKeyword, page, pageSize]);
  useEffect(() => {
    const projectId = JSON.parse(localStorage?.getItem("projectID"));
    handleExportData(projectId);
  }, []);
  const getData = async (Id) => {
    try {
      const payload = {
        modelName: "inwards",
        whereCondition: {
          project_id: Id,
        },
        relations: [
          {
            module: "projects",
            moduleAs: "project",
          },
          {
            module: "orders",
            moduleAs: "order",
          },
          {
            module: "invoices",
            moduleAs: "invoice",
          },
          {
            module: "warehouse_masters",
            moduleAs: "warehouse",
          },
          {
            module: "user_masters",
            moduleAs: "contractor",
          },
          {
            module: "user_masters",
            moduleAs: "createdBy",
          },
        ],
        search: {
          searchKeyword: searchKeyword,
          field_name: [
            "delivery_challen_no",
            "order.order_no",
            "invoice.invoice_no",
            "warehouse.warehouse_name",
            "contractor.first_name",
            "inward_no",
            "remarks",
            "createdBy.first_name",
          ],
        },
        pagination: {
          page: page + 1,
          pageSize: pageSize,
        },
      };

      const responseData = await getRecords(payload, "/listInward");

      // Assign an `index` property starting from 1
      responseData.data.forEach((element, index) => {
        element.index = index + 1;
      });
      setTotalCount(responseData.count);

      const sortedData = responseData.data.sort((a, b) => b.index - a.index);
      setData(sortedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClickAdd = () => {
    navigate("/inward-create");
  };

  const handleEditClick = (id) => {
    navigate(`/inward-create/${id}`);
  };
  const handleViewClick = (id) => {
    navigate(`/inward-view/${id}`);
  };

  const getSearchInputData = (inputValue) => {
    setSearchKeyword(inputValue);
  };

  const nextToPages = () => {
    setPage(page + 1);
  };

  const previousToPages = () => {
    setPage(page - 1);
  };

  const handlePageSizeChange = (data) => {
    setPageSize(data);
    const newTotalPages = Math.ceil(totalCount / data);
    if (page >= newTotalPages) {
      setPage(0);
    }
  };

  const lastToPages = () => {
    setPage(Math.ceil(totalCount / pageSize) - 1);
  };

  const previousFirstToPages = () => {
    setPage(0);
  };

  const columns = useMemo(
    () => [
      {
        Header: "SR.NO",
        accessor: "index",
        accessor: (row) => page * pageSize + row.index,
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "50px" }}>{value}</div>,
      },

      {
        Header: "INVOICE NO",
        accessor: (row) =>
          row?.invoice?.invoice_no && row?.invoice?.invoice_no
            ? row?.invoice?.invoice_no
            : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "INWARD NO",
        accessor: (row) =>
          row?.inward_no && row?.inward_no ? row?.inward_no : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "INWARD DATE",
        accessor: (row) =>
          row?.updatedAt && row?.updatedAt ? formatDate(row?.updatedAt) : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },

      {
        Header: "SO No",
        accessor: (row) =>
          row?.order && row?.order?.order_no ? row?.order.order_no : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },

      {
        Header: "REMARK",
        accessor: (row) => (row?.remarks && row?.remarks ? row?.remarks : "-"),
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "CREATED BY",
        accessor: (row) =>
          row?.createdBy && row?.createdBy?.first_name
            ? row?.createdBy?.first_name + " " + row?.createdBy?.last_name
            : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "INWARD STATUS",
        accessor: "is_submitted",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => (
          <div style={{ width: "100px" }}>
            {value === false ? (
              <span className="badge bg-warning-subtle text-warning text-uppercase">
                Draft
              </span>
            ) : (
              <span className="badge bg-success-subtle text-success text-uppercase">
                Submitted
              </span>
            )}
          </div>
        ),
      },
      {
        Header: "STATUS",
        accessor: "is_active",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => (
          <div style={{ width: "100px" }}>
            {value === false || value === 0 ? (
              <span className="badge bg-danger-subtle text-danger text-uppercase">
                In-active
              </span>
            ) : (
              <span className="badge bg-success-subtle text-success text-uppercase">
                Active
              </span>
            )}
          </div>
        ),
      },
      {
        Header: "ACTION",
        accessor: "actions",
        disableFilters: true,
        filterable: false,
        Cell: ({ row }) => (
          <div style={{ width: "150px", display: "flex" }}>
            {row?.original?.is_submitted == false ? (
              <div
                onClick={() => {
                  handleEditClick(row.original.id);
                }}
              >
                <Link className="me-3 text-primary">
                  <i className="mdi mdi-pencil font-size-18"></i>
                </Link>
              </div>
            ) : (
              <div style={{ visibility: "hidden" }}>
                <Link className="me-3 text-primary">
                  <i className="mdi mdi-pencil font-size-18"></i>
                </Link>
              </div>
            )}
            <div
              onClick={() => {
                handleViewClick(row.original.id);
              }}
            >
              <Link className="me-3 text-primary">
                <i className="mdi mdi-eye font-size-18"></i>
              </Link>
            </div>
          </div>
        ),
      },
    ],
    [page, pageSize]
  );

  const handleExportData = async (projectId) => {
    try {
      exportPageData.data.whereCondition = {
        project_id: projectId,
      };
      const responseData = await getRecords(
        exportPageData?.data,
        "/getRecords"
      );
      if (responseData?.data.length == 0) setExportData([]);
      const exportData = responseData?.data.map((item, index) => ({
        "SR. NO": index + 1,
        "INVOICE NO": item?.invoice?.invoice_no || "-",
        "INWARD NO": item?.inward_no || "-",
        "INWARD DATE": item.updatedAt || "N/A",
        "SO No": item?.order?.order_no || "-",
        REMARK: item?.remarks || "-",
        "CREATED BY":
          item?.createdBy?.first_name + " " + item?.createdBy?.last_name || "-",
        "INWARD STATUS": item?.is_submitted ? "SUBMITTED" : "DRAFT" || "N/A",
        STATUS:
          item?.is_active === false || item?.is_active === 0
            ? "In-active"
            : "Active",
      }));
      setExportData(exportData);
    } catch (error) {
      console.error("Error fetching records:", error);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <Breadcrumb title="Inward List" breadcrumbItems={breadcrumbItems} />
            <Button
              color="primary"
              className="waves-effect waves-light me-1"
              onClick={handleClickAdd}
              style={{ marginLeft: "auto", background: "#006eb9" }}
            >
              Create Inward
            </Button>
          </div>

          <Card>
            <CardBody>
              <TableContainer
                columns={columns || []}
                data={data || []}
                isPagination={false}
                // isGlobalFilter={false}
                iscustomPageSize={false}
                isBordered={false}
                customPageSize={10}
                isLoading={isLoading}
                onSearchInputData={getSearchInputData}
                pageIndexProp={page}
                onPageSizeChange={handlePageSizeChange}
                nextToPage={nextToPages}
                lastToPage={lastToPages}
                previousToPage={previousToPages}
                previousFirstToPage={previousFirstToPages}
                totalCount={totalCount}
                exportData={exportData}
                exportFileName={exportPageData?.fileName}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default InwardList;
